// validateForm.ts
import { ValidationErrors } from './validationErrors';

type Translator = (key: string) => string;

type Validator<T, K extends keyof T> = (value: T[K], data: T) => string | null;

export type ValidationSchema<T> = {
  [K in keyof T]?: Validator<T, K>[];
};

export const validateForm = <T>(
    data: T,
    schema: ValidationSchema<T>,
    t: Translator
  ): ValidationErrors<T> => {
    const errors: ValidationErrors<T> = {};
  
    for (const field in schema) {
      const validators = schema[field as keyof T];
  
      if (validators) {
        for (const validate of validators) {
          const error = validate(data[field as keyof T], data);
          if (error) {
            errors[field as keyof T] = t(error); // Translate error key
            break; // Stop at first error for a field
          }
        }
      }
    }
  
    return errors;
  };
  
